import SlsPicClient from '@/api/Operacoes/sls-pic.client';
import { ErrorMessage } from '@/libs/Error';
import SLS_pedidosVendasService from '@/services/Operacoes/sls_pedidoVendas.service';
import SLSParametrosService from '@/services/SistemaDKP/SLSParametros.service';
import InitialDataService from '@/services/InitialData.service';
import Store from '@/store';

export default class InfoPedidoService {
  constructor() {
    this.client = new SLS_pedidosVendasService();
    this.clientPic = new SlsPicClient();
    this.slsParametrosService = new SLSParametrosService();
    this.error = new ErrorMessage();
    this.store = Store;
  }

  async getEmbalagemByFamComercialId() {
    try {
      const item = this.store.getters['InfoPedido/GET_ITEM_SELECTED'];

      const formInfoPedido = this.store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'];
      let tabelaPrecoId;

      if (formInfoPedido && formInfoPedido.tabelaPreco && formInfoPedido.tabelaPreco.tabelapreco_id) {
        tabelaPrecoId = formInfoPedido.tabelaPreco.tabelapreco_id;
        console.log('Usando tabela de preço do pedido:', tabelaPrecoId);
      } else {
        let tabelaLocalStorage = null;

        try {
          const userId = InitialDataService.getUserId();
          if (userId && userId !== 'default') {
            const savedFormData = localStorage.getItem(`infoPedidoForm_${userId}`);
            if (savedFormData) {
              const parsedData = JSON.parse(savedFormData);

              // Verificar se o cache é válido (da sessão atual)
              if (InitialDataService.isValidCache(parsedData) && parsedData.tabelaPreco?.tabelapreco_id) {
                tabelaLocalStorage = parsedData.tabelaPreco.tabelapreco_id;
                console.log('Usando tabela de preço do localStorage (cache válido):', tabelaLocalStorage);
              } else {
                // Cache inválido, remover
                localStorage.removeItem(`infoPedidoForm_${userId}`);
                console.log('Cache inválido removido, buscando tabela padrão');
              }
            }
          }
        } catch (error) {
          console.error('Erro ao recuperar tabela de preço do localStorage:', error);
        }

        if (tabelaLocalStorage) {
          tabelaPrecoId = tabelaLocalStorage;
        } else {
          const tabelaPrecoPadrao = await this.slsParametrosService.findByDescricao('TABELA_PRECO_PADRAO');
          tabelaPrecoId = tabelaPrecoPadrao.parametro_valor;
          console.log('Usando tabela de preço padrão:', tabelaPrecoId);
        }
      }

      const { data } = await this.client.itensEmbalagemPedido(item.familia_comercial_id, tabelaPrecoId);
      this.store.commit('slsEmbalagem/setEsEmbalg', data.map((emb) => ({ des_embalag: emb.des_embalag, cdn_embalagem: emb.cdn_embalagem })));
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os items');
      return [];
    }
  }

  async getPicPedidos() {
    // Funcionalidade PIC parametrizada por tenant (PIC_ATIVO, padrão desligado):
    // quando inativa, não busca PICs (evita 403 do backend e opções residuais).
    if (this.store.getters['preferencias/picAtivo'] !== true) {
      this.store.commit('InfoPedido/SET_OPTIONS_PIC_PEDIDO', []);
      return [];
    }
    try {
      const formInfoPedido = this.store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'];
      const paramsPicPedido = {
        estabelecimentoid: formInfoPedido.estabelecimentoid,
        condicaopagamentoid: formInfoPedido.condicaoPagamento.condicaopagamentoid,
        clienteId: formInfoPedido.cliente.clienteid,
        tabelaprecoId: formInfoPedido.tabelaPreco.tabelapreco_id,
      };
      const { data } = await this.clientPic.getPicFindBySituacao(paramsPicPedido);
      this.store.commit('InfoPedido/SET_OPTIONS_PIC_PEDIDO', data);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os items');
    }
  }
}
